module.exports = __webpack_public_path__ + "img/twitch.94df6cdf.svg";